import { type MRT_Localization } from "material-react-table";

export const MRT_Localization_TA: MRT_Localization = {
  language: "ta",
  actions: "செயல்கள்",
  and: "மற்றும்",
  cancel: "ரத்து செய்",
  changeFilterMode: "வடிகட்டி பயன்முறையை மாற்று",
  changeSearchMode: "தேடல் பயன்முறையை மாற்று",
  clearFilter: "வடிகட்டியை அழி",
  clearSearch: "தேடலை அழி",
  clearSelection: "தேர்வை அழி",
  clearSort: "வரிசையை அழி",
  clickToCopy: "நகலெடுக்க கிளிக் செய்",
  copy: "நகலெடு",
  collapse: "சுருக்கு",
  collapseAll: "அனைத்தையும் சுருக்கு",
  columnActions: "நெடுவரிசை செயல்கள்",
  copiedToClipboard: "கிளிப்போர்டுக்கு நகலெடுக்கப்பட்டது",
  dropToGroupBy: "குழுவாக்க {column} இல் விடு",
  edit: "திருத்து",
  expand: "விரிவாக்கு",
  expandAll: "அனைத்தையும் விரிவாக்கு",
  filterArrIncludes: "உள்ளடக்கியது",
  filterArrIncludesAll: "அனைத்தையும் உள்ளடக்கியது",
  filterArrIncludesSome: "உள்ளடக்கியது",
  filterBetween: "இடையில்",
  filterBetweenInclusive: "உள்ளடக்கிய இடையில்",
  filterByColumn: "{column} மூலம் வடிகட்டு",
  filterContains: "உள்ளடக்கியது",
  filterEmpty: "வெற்று",
  filterEndsWith: "முடிவடைகிறது",
  filterEquals: "சமம்",
  filterEqualsString: "சமம்",
  filterFuzzy: "தெளிவற்ற",
  filterGreaterThan: "அதிகம்",
  filterGreaterThanOrEqualTo: "அதிகம் அல்லது சமம்",
  filterInNumberRange: "இடையில்",
  filterIncludesString: "உள்ளடக்கியது",
  filterIncludesStringSensitive: "உள்ளடக்கியது",
  filterLessThan: "குறைவு",
  filterLessThanOrEqualTo: "குறைவு அல்லது சமம்",
  filterMode: "வடிகட்டி பயன்முறை: {filterType}",
  filterNotEmpty: "வெற்று அல்ல",
  filterNotEquals: "சமம் அல்ல",
  filterStartsWith: "தொடங்குகிறது",
  filterWeakEquals: "சமம்",
  filteringByColumn: "{column} மூலம் வடிகட்டுதல் - {filterType} {filterValue}",
  goToFirstPage: "முதல் பக்கத்திற்கு செல்",
  goToLastPage: "கடைசி பக்கத்திற்கு செல்",
  goToNextPage: "அடுத்த பக்கத்திற்கு செல்",
  goToPreviousPage: "முந்தைய பக்கத்திற்கு செல்",
  grab: "பிடி",
  groupByColumn: "{column} மூலம் குழுவாக்கு",
  groupedBy: "குழுவாக்கப்பட்டது ",
  hideAll: "அனைத்தையும் மறை",
  hideColumn: "{column} நெடுவரிசையை மறை",
  max: "அதிகபட்சம்",
  min: "குறைந்தபட்சம்",
  move: "நகர்த்து",
  noRecordsToDisplay: "காட்ட எந்த பதிவுகளும் இல்லை",
  noResultsFound: "எந்த முடிவுகளும் கிடைக்கவில்லை",
  of: "இல்",
  or: "அல்லது",
  pin: "பின்",
  pinToLeft: "இடதுபுறம் பின்",
  pinToRight: "வலதுபுறம் பின்",
  resetColumnSize: "நெடுவரிசை அளவை மீட்டமை",
  resetOrder: "வரிசையை மீட்டமை",
  rowActions: "வரிசை செயல்கள்",
  rowNumber: "#",
  rowNumbers: "வரிசை எண்கள்",
  rowsPerPage: "பக்கத்திற்கு வரிசைகள்",
  save: "சேமி",
  search: "தேடு",
  selectedCountOfRowCountRowsSelected:
    "{selectedCount} இல் {rowCount} வரிசை(கள்) தேர்ந்தெடுக்கப்பட்டது",
  select: "தேர்ந்தெடு",
  showAll: "அனைத்தையும் காட்டு",
  showAllColumns: "அனைத்து நெடுவரிசைகளையும் காட்டு",
  showHideColumns: "நெடுவரிசைகளை காட்டு/மறை",
  showHideFilters: "வடிகட்டிகளை காட்டு/மறை",
  showHideSearch: "தேடலை காட்டு/மறை",
  sortByColumnAsc: "{column} மூலம் ஏறுவரிசையில் வரிசைப்படுத்து",
  sortByColumnDesc: "{column} மூலம் இறங்குவரிசையில் வரிசைப்படுத்து",
  sortedByColumnAsc: "{column} மூலம் ஏறுவரிசையில் வரிசைப்படுத்தப்பட்டது",
  sortedByColumnDesc: "{column} மூலம் இறங்குவரிசையில் வரிசைப்படுத்தப்பட்டது",
  thenBy: ", பின்னர் ",
  toggleDensity: "அடர்த்தியை மாற்று",
  toggleFullScreen: "முழுத்திரையை மாற்று",
  toggleSelectAll: "அனைத்தையும் தேர்ந்தெடுக்க மாற்று",
  toggleSelectRow: "வரிசையை தேர்ந்தெடுக்க மாற்று",
  toggleVisibility: "தோற்றத்தை மாற்று",
  ungroupByColumn: "{column} மூலம் குழுவைக் கலை",
  unpin: "பினை நீக்கு",
  unpinAll: "அனைத்து பின்களையும் நீக்கு",
};
